import React, { Component } from "react";
import { Link } from "react-router-dom";

class SubNavPhotography extends Component {
  render() {
    return (
      <div className="subnav">
        <ul align="center">
          <li className="subnav-item">
            <Link to="/photography/con">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1542833761/rtds_work/Logo/conCrisostomoMakeupLogo.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/photography/omg">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540401409/rtds_work/Logo/OMGLogoMockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/photography/mck">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540406172/rtds_work/Business%20Collaterals/MCKBusiness-card-mockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default SubNavPhotography;



// WEBPACK FOOTER //
// ./src/components/pages/category/SubNavPhotography.js